/* eslint-disable max-len */

export const bkComponentTokens = {} as const;
